<template>
<div>
  <b-card>
    <div class="form-group">
      <div v-for="item in this.examples">
        {{ item.title }}
        <b-form-input v-model="item.pivot.value"></b-form-input>
      </div>
    </div>
    <div class="form-group">
      <button @click="changeExamples" class="btn btn-success btn-lg" style="font-size: 15px;">
        <i class="mdi mdi-check-circle"></i> Зберегти
      </button>
    </div>
  </b-card>
</div>
</template>

<script>
export default {
  name: "Examples",
  data(){
    return {
      examples:null
    }
  },
  mounted() {
    this.getExamples();
  },
  methods:{
    getExamples(){
      axios.get('/library/settings/examples').then(response => {
        console.log(response.data);
        this.examples = response.data;
      });
    },
    changeExamples(){
      axios({
        url:'/library/settings/examples',
        method:'put',
        data:this.examples.map(el => el.pivot.value),
      }).then(response => {
        this.examples = response.data;
        toastr.success("Збережено");
      });
    }
  },
}
</script>

<style scoped>

</style>